import React from 'react';
import ReactDOM from 'react-dom';
import loadScript from 'scriptjs';

import { STATIC_ROOT } from '../../constants';
import SvgComponent from '../SvgComponent';

import './GoogleMaps.scss';

const GOOGLE_MAPS_API_KEY = 'AIzaSyA5Ov5KlT3VJ4feRkl0Cc9oiHJmDmItjZw';

const makeCustomMarkerClass = api =>
    class CustomMarkerClass extends api.OverlayView {
        constructor(component, ref, map, api) {
            super();
            this.div = null;
            this.component = component;
            this.ref = ref;
            this.map = map;
            this.api = api;

            this.setMap(map);
        }

        onAdd() {
            this.div = document.createElement('div');
            this.div.style.position = 'absolute';
            ['mousedown', 'mouseup', 'mousemove', 'dblclick'].forEach(event => {
                this.api.event.addDomListener(this.div, event, e => {
                    e.cancelBubble = true;
                    if (e.stopPropagation) {
                        e.stopPropagation();
                    }
                });
            });

            const panes = this.getPanes();
            panes.overlayMouseTarget.appendChild(this.div);
            ReactDOM.render(this.component, this.div);
        }

        draw() {
            const { lat, lng } = this.component.props.position;
            const projection = this.getProjection() || {
                fromLatLngToDivPixel: () => ({})
            };
            const { x, y } = projection.fromLatLngToDivPixel(new api.LatLng(lat, lng));
            this.div.style.top = y + 'px';
            this.div.style.left = x + 'px';
        }

        onRemove() {
            if (this.div && this.div.parentNode) {
                this.div.parentNode.removeChild(this.div);
            }
        }

        activate(state) {
            this.ref.current.setState({ active: state });
        }
    };

class MapComponent extends React.Component {
    constructor(props) {
        super(props);
        this.$root = React.createRef();
        this.map = null;
        this.bounds = null;
        this.markers = [];
        this.CustomMarker = makeCustomMarkerClass(props.api);
    }

    componentDidMount() {
        this.initMap();
        this.updateMap();
    }

    componentDidUpdate() {
        this.updateMap();
    }

    centerMap = () => {
        if (this.bounds.isEmpty()) {
            this.map.setCenter(this.props.center || { lat: 48.8566, lng: 2.3522 });
            this.map.setZoom(this.props.zoom || 1);
        } else {
            this.map.fitBounds(this.bounds);
            this.map.panToBounds(this.bounds);
        }
    };

    addMarker = (elt, index) => {
        if (!elt) return null;
        const ref = React.createRef();
        const Marker = React.cloneElement(elt, {
            onHover: state =>
                this.map.setOptions({
                    gestureHandling: state ? 'none' : 'auto'
                }),
            onActivate: state => {
                this.markers.forEach((m, i) => {
                    if (!m) return;
                    if (i === index) {
                        m.activate(!state);
                        if (!state) {
                            this.map.panTo(elt.props.position);
                            this.map.panBy(0, -100);
                        }
                    } else {
                        m.activate(false);
                    }
                });
            },
            ref
        });
        this.bounds.extend(elt.props.position);
        return new this.CustomMarker(Marker, ref, this.map, this.props.api);
    };

    initMap = () => {
        const { api, options } = this.props;

        this.map = new api.Map(this.$root.current, {
            ...options
        });
    };

    updateMap = () => {
        const { api, children } = this.props;

        this.bounds = new api.LatLngBounds();

        this.markers.forEach(m => {
            if (m) {
                m.onRemove();
            }
        });
        this.markers = [];

        React.Children.forEach(children, (child, index) => {
            const marker = this.addMarker(child, index);
            this.markers.push(marker);
        });

        this.centerMap();
    };

    zoomIn = () => {
        this.map.setZoom(this.map.getZoom() + 1);
    };

    zoomOut = () => {
        this.map.setZoom(this.map.getZoom() - 1);
    };

    fullScreen = () => {
        var map = document.querySelector('.gm-style');
        map.mozRequestFullScreen();
    };

    render() {
        return (
            <div className="mapContainer">
                <div ref={this.$root} style={{ ...this.props.style }} />
                <div className="zoom">
                    <button onClick={this.zoomIn}>
                        <SvgComponent className="zplus" src={`${STATIC_ROOT}/maps/zoom_plus.svg`} />
                    </button>
                    <button onClick={this.zoomOut}>
                        <SvgComponent
                            className="zmoins"
                            src={`${STATIC_ROOT}/maps/zoom_moins.svg`}
                        />
                    </button>
                </div>
                <button className="fullscreen" onClick={this.fullScreen}>
                    <SvgComponent src={`${STATIC_ROOT}/maps/loupe.svg`} />
                    Agrandir la carte
                </button>
            </div>
        );
    }
}

const parseChildren = (children, api) =>
    React.Children.map(children, child => {
        if (!child) return null;
        if (child.type === MapComponent) {
            return React.cloneElement(child, { api });
        }
        return child.props
            ? React.cloneElement(child, { children: parseChildren(child.props.children, api) })
            : child;
    });

class ReactMap extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            mapApi: null,
            geocoder: null
        };
    }

    componentDidMount() {
        if (!window.google || !window.google.maps) {
            loadScript(`https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAPS_API_KEY}`, () => {
                this.setApi();
            });
        } else {
            this.setApi();
        }
    }

    setApi = () => {
        this.setState({
            mapApi: window.google.maps,
            geocoder: new window.google.maps.Geocoder(),
            loading: false
        });
    };

    render() {
        return this.state.loading
            ? 'Loading...'
            : parseChildren(
                  this.props.children({
                      Map: MapComponent,
                      getAddress: address =>
                          new Promise((resolve, reject) => {
                              if (!address) {
                                  reject();
                              } else {
                                  this.state.geocoder.geocode(
                                      { address },
                                      (results, status) =>
                                          status === 'OK'
                                              ? resolve(results[0].geometry.location.toJSON())
                                              : reject()
                                  );
                              }
                          })
                  }),
                  this.state.mapApi
              );
    }
}

export default ReactMap;



// WEBPACK FOOTER //
// ./src/components/googlemaps/index.js